<template>
  <div class="DataMappingDepartmentWrapper">
    <slot />
  </div>
</template>

<script>
import './style.scss'

export default {
  name: 'DataMappingDepartmentWrapper',
}
</script>
